import { render, staticRenderFns } from "./WorkflowActivitiesValidationFields.vue?vue&type=template&id=fb98b6ba&lang=pug&"
import script from "./WorkflowActivitiesValidationFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowActivitiesValidationFields.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports